<script setup>
defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['click'])

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: 'button'
  },
  variant: {
    type: String,
    default: 'primary'
  },
  size: {
    type: String,
    default: 'md'
  }
})

const attrs = useAttrs()

const isDisabled = computed(() => props.disabled || props.loading)

const variantClasses = computed(() => {
  if (props.variant === 'secondary') return 'btn-outline'
  if (props.variant === 'danger') return '!bg-rose-50 !border-rose-100 !text-rose-600 hover:!bg-rose-100'
  if (props.variant === 'ghost-danger') return '!bg-transparent !border-transparent !shadow-none !text-rose-600 hover:!bg-rose-50'
  return ''
})

const sizeClasses = computed(() => {
  if (props.size === 'small') return 'btn-small'
  return ''
})

const buttonClasses = computed(() => [
  'btn',
  variantClasses.value,
  sizeClasses.value
])

const handleClick = (event) => {
  if (isDisabled.value) {
    event.preventDefault()
    return
  }

  emit('click', event)
}
</script>

<template>
  <button
    v-bind="attrs"
    :type="type"
    :disabled="isDisabled"
    :class="buttonClasses"
    @click="handleClick"
  >
    <Icon v-if="loading" name="eos-icons:three-dots-loading" class="place-self-center" />
    <span class="flex items-center justify-center gap-2" :class="{ invisible: loading }">
      <Icon v-if="icon" :name="icon" />
      <slot />
    </span>
  </button>
</template>
